import { BaseEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-services';
import {
    PcEditorViewableServiceLayer,
} from '@src/slide/application/entry/toc/editor/pc/service-layer/viewable-service-layer';
import {
    PcEditorEditableServiceLayer,
} from '@src/slide/application/entry/toc/editor/pc/service-layer/editable-service-layer';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import {
    IPcEditorEditableServiceLayer,
} from '@src/slide/application/entry/toc/editor/pc/service-layer/editable-service-layer.interface';
import {
    IPcEditorViewableServiceLayer,
} from '@src/slide/application/entry/toc/editor/pc/service-layer/viewable-service-layer.interface';
import { InfrastructurePc } from '@src/slide/infrastructure/entry/pc/infrastucture-pc';
import { IInfrastructureBase } from '@src/slide/infrastructure/entry/base/infrastructure-base.interface';

export class PcEditorAppServices extends BaseEditorAppServices implements IPcEditorAppServices {
    public editableServiceLayer?: IPcEditorEditableServiceLayer;
    declare public viewableServiceLayer: IPcEditorViewableServiceLayer;

    public constructor() {
        super();
        this.editableServiceLayer = this.createEditableServiceLayer();
    }

    protected createEditableServiceLayer(): IPcEditorEditableServiceLayer {
        return new PcEditorEditableServiceLayer(
            this.viewableServiceLayer,
            this.getUiDataService(),
            this.getInfrastructureService(),
        );
    }

    protected createViewableServiceLayer(): IPcEditorViewableServiceLayer {
        return new PcEditorViewableServiceLayer(this.getUiDataService(), this.getInfrastructureService());
    }

    protected newInfrastructureService(): IInfrastructureBase {
        return new InfrastructurePc();
    }
}
